module.exports = __webpack_public_path__ + "media/images/lb/195-6e2fcf3846084f4ae5ee7e24c4b0fd43.svg";